import angular from 'angular';
import paylocityComponent from './paylocity.component';
import payroll from './capabilities/payroll/paylocity-payroll';
import employeeMapping from './capabilities/employee-mapping/paylocity-employee-mapping';
import payrollDetailCodes from './capabilities/payroll-detail-codes/paylocity-payroll-detail-codes';

let paylocityModule = angular.module('paylocity', [
  payroll.name, employeeMapping.name, payrollDetailCodes.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('paylocity', {
    parent: 'app',
    url: '/admin/integrations/paylocity',
    data: {
      pageHeader: true,
      pageTitle: 'Paylocity Integration Capabilities',
      pageDesc: '',
      breadcrumbLink: 'admin.integrations',
      breadcrumbText: 'View All Integrations'
    },
    template: '<paylocity></paylocity>'
  })



})

.component('paylocity', paylocityComponent);

export default paylocityModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/paylocity.js